export default "__VITE_ASSET__B6GCX9Z5__"